// Index & PK Health Advisor API client (admin). Read-only analyze + the
// server-allowlisted safe-drop apply (the server re-derives what's safe; the
// client only nominates which of the safe drops to run).
import { api } from './api.js';

// → { findings: [{schema,table,index,columns,kind,detail,coveredBy,safe,sql}],
//     scanned: { tables, indexes } }
// connectionId comes from a <select> (a string); the Go handler wants int64.
export const analyzeIndexHealth = (connectionId, database) =>
  api.post('/api/tools/index-health/analyze', { connectionId: Number(connectionId), database: database || '' });

// drops: [{schema,table,index}]. onError: 'stop' | 'continue'.
// → { results: [{schema,table,index,ok,error?}], ran, failed, skipped, ok }
export const applyIndexDrops = (connectionId, drops, onError = 'stop') =>
  api.post('/api/tools/index-health/apply', { connectionId: Number(connectionId), drops, onError });
